export default defineAppConfig({
  ui: {
    colors: {
      primary: 'primary',
      secondary: 'secondary',
      success: 'green',
      info: 'sky',
      warning: 'amber',
      error: 'red',
      neutral: 'slate',
    },
    header: {
      slots: {
        root: 'bg-primary text-inverted border-b border-primary-950 h-(--ui-header-height) sticky top-0 z-50',
        title: 'shrink-0 font-bold text-xl text-inverted flex items-end gap-1.5',
        toggle: 'lg:hidden text-inverted',
        container: 'flex items-center justify-between gap-3 h-full px-4 max-w-full',
      },
    },
    button: {
      slots: {
        base: 'cursor-pointer disabled:cursor-not-allowed aria-disabled:cursor-not-allowed',
      },
    },
    alert: {
      slots: {
        title: 'text-highlighted',
        description: 'text-highlighted',
      },
    },
  },
});
